<template>
  <v-dialog v-model="visible" width="450" style="overflow-x: hidden!important;">
    <v-card class="cardStyle">
      <v-card-title class="headline lighten-2 titleCard" primary-title>
        <span>
          {{ title }}
        </span>
        <v-icon style="position: absolute; right: 15px" large @click="reject">
          mdi-close
        </v-icon>
      </v-card-title>
      <v-card-actions>
        <div>
          <v-row style="margin-left: 10px">
            <div v-for="item in items" :key="item._id" class="background-color">
              <v-row @click="openDialigCollateral(item.factoring)">
                <div class="col-auto" style="align-self: center">
                  <img v-if="item.image.originalName && !item.image.originalName.toLowerCase().endsWith('.pdf')" align="left" style="margin-right: auto" :src="'/api/uploads/' + item.image.originalName" sizes="small" height="48px" width="48px">
                  <div v-if="item.image.originalName && item.image.originalName.toLowerCase().endsWith('.pdf')" style="max-height: 48px; max-width: 48px; overflow: hidden">
                    <pdf :src="'/api/uploads/' + item.image.originalName" sizes="small" align="left" style="margin-right: auto;" />
                  </div>
                </div>
                <div class="col" style="padding-left: 5px;line-height: 24px">
                  <div style="font-size:16px;">
                    <div> <b> {{ item.factoring.payer.name }} </b>{{ $t('Pay') }} <b>{{ item.factoring.formulaCalc.ABini }}€</b> {{ $t('to') }} <b> {{ item.factoring.receiver.name }}</b>  </div>
                    <div> {{ $t('Limit') }} <b>{{ showDate(item.factoring.invoice.dueDate) }}</b> </div>
                  </div>
                </div>
                <div class="col-auto" style="align-self: center">
                  <v-icon style="margin-right: 5px">
                    arrow_upward
                  </v-icon>
                </div>
              </v-row>
              <v-divider class="borderDividerArchived" />
            </div>
          </v-row>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import ApiRepository from "@/repositories/ApiRepository";

export default {
    name: "CollateralModal",
    components: {
    },
    data: () => ({
        visible: false,
        title: "Title",
        message: "Message",
        onYes: null,
        onNo: null,
        items: [],
    }),
    created () {
        this.$root.$on('show-invoicesToMarket-modal', (event) => {
            this.handleCallbacks(event);
            this.setInformation(event);
            this.show(event);
        });
    },
    methods: {
        openDialigCollateral (factoring) {
            this.$root.$emit('show-collateral-modal', {
                title: this.$t('Collateral'),
                message: this.$t('Do you want to publish this bypay?'),
                factoring: factoring._id,
                yes: () => {
                    this.accept();
                },
            });
        },
        getNameUser (invoice, payer) {
            const user = payer ? invoice.receiver : invoice.payer;
            let name = "unknown";
            if (user && user.name) {
                name = user.name;
                if (user.surname) {
                    if (name.length > 0) name += " ";
                    name += user.surname;
                }
            } else if (user && user.cif) {
                name = user.cif;
            } else if (user && user.email) {
                name = user.email;
            }
            return name;
        },
        showDate (date) {
            if (date) {
                const d = new Date(date);
                return ((d.getDay() + 1) + "-" + (d.getMonth() + 1) + "-" + d.getFullYear());
            } else {
                return "--/--/----";
            }
        },
        handleCallbacks (event) {
            if (typeof event.yes === 'function') {
                this.$data.onYes = event.yes;
            }
            if (typeof event.no === 'function') {
                this.$data.onNo = event.no;
            }
        },
        show () {
            this.visible = true;
        },
        hide () {
            this.visible = false;
        },
        accept () {
            if (this.$data.onYes) {
                this.$data.onYes();
            }
            this.hide();
        },
        reject () {
            if (this.$data.onNo) {
                this.$data.onNo();
            }
            this.hide();
        },
        setInformation (jInfo) {
            this.title = jInfo.title;
            this.message = jInfo.message;
            ApiRepository.getAllByppaysToAddMarket().then((res) => {
                this.items = res.data.items;
            }).catch((err) => {
                this.$root.$emit('show-snackbar', {message: this.$t(err.response.data.errorCode), color: "error"});
                console.log(err);
            });
        },
    },
};
</script>
<style>

</style>
